module.exports = __webpack_public_path__ + "static/cloud-storage-copy@3x-97d3b90bcd115320a79e4d05b85f9070.png";